import { lintrk } from 'nextjs-linkedin-insight-tag';
import analytics from '../lib/analytics';

export * from './FooterLinks';
export * from './canonical';

const LinkedinConversionId = process.env.NX_LINKEDIN_CONVERSION_ID;

export const handleBookDemo = () => {
  analytics.track('click_book_demo', {
    category: 'Click Event',
    label: 'book-demo',
  });

  lintrk('track', { conversion_id: LinkedinConversionId });

  window.open('/l/jove-customer-call', '_blank', 'noopener,noreferrer');
};

export const handleTracking = () => {
  analytics.track('click_book_demo', {
    category: 'Click Event',
    label: 'book-demo',
  });

  lintrk('track', { conversion_id: LinkedinConversionId });
};

export const syncUrlQueryParams = (params: Record<any, any>) => {
  const qs = new URLSearchParams(window.location.search);

  Object.keys(params).map((key) => {
    if (params[key] && (!Array.isArray(params[key]) || params[key].length > 0)) {
      qs.set(key, params[key].toString());
    } else {
      qs.delete(key);
    }
  });

  window.history.replaceState(null, '', `?${qs.toString()}`);
};

export const syncFiltersFromQueryParams = (): Record<any, any> => {
  const qs = new URLSearchParams(window.location.search);
  const res = {};
  const entries = qs.entries();

  for (const [key, value] of entries) {
    if (key.includes('[]')) {
      res[key.replace('[]', '')] = [...value.split(',')];
    } else {
      res[key] = value;
    }
  }

  return res;
};
